import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import placeholder from "@/assets/img-placeholder.svg";
import styles from "./fix-image-placeholder.module.scss";
import { useLayoutType, LayoutStyleTypes, LayoutTypes } from "@/util-react/layout";
import { Icon } from "@/elements-react/fix-icon";

export interface FixImagePlaceholderProps {
  type?: LayoutStyleTypes.TYPE_LG | LayoutStyleTypes.TYPE_SM;
  className?: string;
}

export const FixImagePlaceholder: React.FC<FixImagePlaceholderProps> = ({ type = LayoutStyleTypes.TYPE_LG, className }) => {
  const { t } = useTranslation();
  return (
    <div className={classNames(styles.container, className)}>
      <Icon
        className={classNames({ [styles["icon-lg"]]: type === LayoutStyleTypes.TYPE_LG, [styles["icon-sm"]]: type === LayoutStyleTypes.TYPE_SM })}
        src={placeholder}
      />
      <span className={classNames({ [styles["label-lg"]]: type === LayoutStyleTypes.TYPE_LG, [styles["label-sm"]]: type === LayoutStyleTypes.TYPE_SM })}>
        {t("pvip7ln0uenv084u.no-photo", "No photo")}
      </span>
    </div>
  );
};

export default FixImagePlaceholder;
